<template>
    <div :style="finished && (list.length == 0 || !list) ? 'padding-top:12px':''">
        <div class="card mt12 notfound" v-if="finished && (list.length == 0 || !list)">
            <van-image
                fit="contain"
                src="https://zanhistest-1252304461.cos.ap-shanghai.myqcloud.com//doctorInfo/2022/12/12/1dd796734dbf4c3fa6987cdb5a1c114c.png"
            />
            <span style="margin-top: 8px;color: #999999;">暂未分配学习计划</span>
        </div>
        <div class="home">
            <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="finished && (list.length == 0 || !list) ? '':'没有更多了'"
                @load="getPlan"
            >
                <ul class="list">
                    <li class="list_item" v-for="item in list" :key="item.id">
                        <div class="item_header">
                            <div
                                class="item_tag"
                                :class="
                                    item.isAllPunch === 'N'
                                        ? 'bg_grey_white'
                                        : '' ||
                                          (item.isNoOne === 'N' &&
                                              item.isAllPunch === 'Y' &&
                                              item.isNeedExamination === 'N')
                                        ? 'bg_green_white'
                                        : '' ||
                                          (item.isNoOne === 'N' &&
                                              item.isAllPunch === 'Y' &&
                                              item.isNeedExamination === 'Y' &&
                                              item.isExamination === 'N')
                                        ? 'bg_red_white'
                                        : '' ||
                                          (item.isNoOne === 'N' &&
                                              item.isAllPunch === 'Y' &&
                                              item.isNeedExamination === 'Y' &&
                                              item.isExamination === 'Y' &&
                                              item.isScore === 'N')
                                        ? 'bg_purple_white'
                                        : '' ||
                                          (item.isNoOne === 'N' &&
                                              item.isAllPunch === 'Y' &&
                                              item.isNeedExamination === 'Y' &&
                                              item.isExamination === 'Y' &&
                                              item.isScore === 'Y')
                                        ? 'bg_green_white'
                                        : ''
                                "
                            >
                                {{ item.isAllPunch === "N" ? "未完成" : "" }}
                                {{
                                    item.isNoOne === "N" &&
                                    item.isAllPunch === "Y" &&
                                    item.isNeedExamination === "N"
                                        ? "已完成"
                                        : ""
                                }}
                                {{
                                    item.isNoOne === "N" &&
                                    item.isAllPunch === "Y" &&
                                    item.isNeedExamination === "Y" &&
                                    item.isExamination === "N"
                                        ? "待考试"
                                        : ""
                                }}
                                {{
                                    item.isNoOne === "N" &&
                                    item.isAllPunch === "Y" &&
                                    item.isNeedExamination === "Y" &&
                                    item.isExamination === "Y" &&
                                    item.isScore === "N"
                                        ? "待评分"
                                        : ""
                                }}
                                {{
                                    item.isNoOne === "N" &&
                                    item.isAllPunch === "Y" &&
                                    item.isNeedExamination === "Y" &&
                                    item.isExamination === "Y" &&
                                    item.isScore === "Y"
                                        ? "已评分"
                                        : ""
                                }}
                            </div>
                            <div
                                class="item_link"
                                @click="toStudy(item)"
                                :class="
                                    item.isNoOne === 'N' &&
                                    item.isAllPunch === 'Y' &&
                                    item.isNeedExamination === 'N'
                                        ? 'color_grey'
                                        : '' ||
                                          (item.isNoOne === 'N' &&
                                              item.isAllPunch === 'Y' &&
                                              item.isNeedExamination === 'Y' &&
                                              item.isExamination === 'Y' &&
                                              item.isScore === 'Y')
                                        ? 'color_yellow'
                                        : ''
                                "
                            >
                                <span>
                                    {{
                                        item.isNoOne === "Y" &&
                                        item.isAllPunch === "N"
                                            ? "开始学习"
                                            : ""
                                    }}
                                    {{
                                        item.isNoOne === "N" &&
                                        item.isAllPunch === "N"
                                            ? "继续学习"
                                            : ""
                                    }}
                                    {{
                                        item.isNoOne === "N" &&
                                        item.isAllPunch === "Y" &&
                                        item.isNeedExamination === "Y" &&
                                        item.isExamination === "N"
                                            ? "立即考试"
                                            : ""
                                    }}
                                    {{
                                        item.isNoOne === "N" &&
                                        item.isAllPunch === "Y" &&
                                        item.isNeedExamination === "N"
                                            ? "无需考试"
                                            : ""
                                    }}
                                    {{
                                        item.isNoOne === "N" &&
                                        item.isAllPunch === "Y" &&
                                        item.isNeedExamination === "Y" &&
                                        item.isExamination === "Y" &&
                                        item.isScore === "N"
                                            ? "考试详情"
                                            : ""
                                    }}
                                    {{
                                        item.isNoOne === "N" &&
                                        item.isAllPunch === "Y" &&
                                        item.isNeedExamination === "Y" &&
                                        item.isExamination === "Y" &&
                                        item.isScore === "Y"
                                            ? item.examinationState
                                            : ""
                                    }}
                                </span>
                                <van-icon
                                    name="arrow"
                                    v-if="
                                        !(
                                            item.isNoOne === 'N' &&
                                            item.isAllPunch === 'Y' &&
                                            item.isNeedExamination === 'N'
                                        )
                                    "
                                />
                            </div>
                        </div>
                        <div class="item_content">
                            {{ item.learningName }}
                        </div>
                        <div class="collapse">
                            <div
                                class="content"
                                :class="
                                    item.isDrop === 'Y' ? 'showContent' : ''
                                "
                            >
                                <div
                                    class="content_item"
                                    v-for="ele in item.items"
                                    :key="ele.id"
                                    :class="
                                        ele.isPunch === 'N' && item.playbackOrder == 1
                                            ? 'color_grey'
                                            : '' || ele.isPunch === 'R' || item.playbackOrder == 2
                                            ? 'color_red'
                                            : ''
                                    "
                                    @click="toStudyById(ele.id, ele.isPunch,item.playbackOrder)"
                                >
                                    <span
                                        >{{ ele.serialNum }}、{{
                                            ele.learningTitle
                                        }}</span
                                    >
                                    <van-icon
                                        v-show="ele.isPunch === 'Y'"
                                        class="checked"
                                        name="checked"
                                    />
                                </div>
                            </div>
                            <div @click="showCollapse(item)" class="collBtn">
                                {{
                                    item.isDrop === "Y"
                                        ? "收起学习内容"
                                        : "展开学习内容"
                                }}
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
            </van-list>
        </div>
    </div>
</template>
<script>
import watermark from "watermark-dom";
import { findUserLearningByUserId } from "@/common/api";
export default {
    data() {
        return {
            list: [],
            loading: false,
            finished: false,
        };
    },
    mounted() {
        const currentUser =
            JSON.parse(localStorage.getItem("currentUser")) || undefined;
        watermark.init({
            watermark_txt: currentUser.name,
        });
    },
    methods: {
        // 展开关闭学习内容
        showCollapse(item) {
            if (item.isDrop === "N") {
                item.isDrop = "Y";
            } else {
                item.isDrop = "N";
            }
        },
        // 获取列表
        async getPlan() {
            // 异步更新数据
            const currentUser =
                JSON.parse(localStorage.getItem("currentUser")) || undefined;
            if (currentUser) {
                const response = await findUserLearningByUserId({
                    userId: currentUser.userId,
                });
                // 加载状态结束
                this.loading = false;
                // 数据全部加载完成
                this.finished = true;
                console.log(this.finished)
                this.list = [...response?.data ?? []];
            }
        },
        // 去学习/考试
        toStudy(item) {
            switch (item.type) {
                case "开始学习":
                    this.$router.push(`/study/${item.id}/class`);
                    break;
                case "继续学习":
                    this.$router.push(`/study/${item.id}/class`);
                    break;
                case "立即考试":
                    this.$router.push(
                        `/examination/${item.examinationId}/class`
                    );
                    break;
                case "考试详情":
                    this.$router.push(
                        `/examination/${item.examinationId}/defails`
                    );
                    break;
            }
        },
        // 通过id，查询当前学习
        toStudyById(id, isPunch,playbackOrder) {
            if (isPunch === "Y" || isPunch === "R" || playbackOrder == 2) {
                this.$router.push(`/study/${id}/item`);
            }
        },
    },
};
</script>
<style lang="less" scoped>
.empty {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.checked {
    color: #4c9d68;
    font-size: 18px;
}
.home {
    .list {
        padding: 15px;
        .list_item {
            margin-bottom: 10px;
            background: white;
            border-radius: 10px;
            .item_header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .item_tag {
                    font-size: 12px;
                    padding: 10px 20px;
                    border-top-left-radius: 10px;
                    border-bottom-right-radius: 10px;
                    color: white;
                }
                .item_link {
                    font-size: 12px;
                    color: var(--van-primary-color);
                    padding-right: 10px;
                    span {
                        padding-right: 10px;
                        font-weight: 600;
                    }
                }
            }
            .item_content {
                padding: 10px;
                font-size: 16px;
                line-height: 26px;
                color: var(--theme-font-color);
                font-weight: 600;
            }
            .collapse {
                width: 100%;
                .content {
                    width: 100%;
                    max-height: 0px;
                    overflow: hidden;
                    transition: all ease 0.2s;
                    .content_item {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        font-size: 14px;
                        padding: 15px 10px;
                        border-top: 1px solid #f7f7f7;
                        span {
                            padding-right: 10px;
                            line-height: 22px;
                        }
                    }
                }
                .showContent {
                    max-height: 9000px;
                }
                .collBtn {
                    text-align: center;
                    padding: 15px 0;
                    border-top: 1px solid #f7f7f7;
                    font-size: 12px;
                    color: var(--theme-vice-font-color);
                }
            }
        }
    }
}
.bg_red_white {
    background: linear-gradient(#c56b6b, #eda0a0);
}
.bg_grey_white {
    background: linear-gradient(#a3a2a2, #d8d8d8);
}
.bg_green_white {
    background: linear-gradient(#36aa83, #81dabc);
}
.bg_purple_white {
    background: linear-gradient(#6f7cb1, #adb1d2);
}
.color_grey {
    color: var(--theme-vice-font-color);
}
.color_yellow {
    color: var(--theme-yellow-color) !important;
}
.color_red {
    color: var(--van-primary-color);
}
.card {
    margin: 0px 12px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    height: 500px;
}
.notfound{
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
   
}
.notfound .van-image{
    width: 48px;
    height: 48px;
}
.tip_text{
    font-size: 12px;
    line-height: 20px;
    color: #999999;
}
</style>
